/**
 * @fileoverview GET handler for the "/engagement/in_app_message_campaigns_and_workflows_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementInAppMessageCampaignsAndWorkflowsData } from "./constants";
import type { EngagementInAppMessageCampaignsAndWorkflowsDataResult } from "./types";
import { isEngagementInAppMessageCampaignsAndWorkflowsDataResult } from "./validators";

export const getEngagementInAppMessageCampaignsAndWorkflowsData = reactQueryFetcherAdapter(
  engagementInAppMessageCampaignsAndWorkflowsData,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementInAppMessageCampaignsAndWorkflowsDataResult> => {
    return fetch(
      "/engagement/in_app_message_campaigns_and_workflows_data",
      "GET",
      { app_group_id: appGroupId },
      { signal }
    );
  },
  isEngagementInAppMessageCampaignsAndWorkflowsDataResult
);
